// extracted by mini-css-extract-plugin
export var cardInfo = "CardInfo_cardInfo__SQmLv";
export var baseLayer = "CardInfo_baseLayer__LYHgy";
export var button = "CardInfo_button__1CgdH";
export var btnWrapper = "CardInfo_btnWrapper__kW5Sg";
export var balance = "CardInfo_balance__uV+mR";
export var dark = "CardInfo_dark__ZclkK";
export var rotate = "CardInfo_rotate__k0d2V";
export var dotty = "CardInfo_dotty__y+bQj";